var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 408,
    height: 489,
    viewBox: "0 0 408 489",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.406 123.109C288.406 151.438 265.419 174.404 237.064 174.404C208.708 174.404 185.721 151.438 185.721 123.109C185.721 94.7792 208.708 71.8135 237.064 71.8135C265.419 71.8135 288.406 94.7792 288.406 123.109ZM259.654 123.109C259.654 135.574 249.54 145.679 237.064 145.679C224.587 145.679 214.473 135.574 214.473 123.109C214.473 110.644 224.587 100.539 237.064 100.539C249.54 100.539 259.654 110.644 259.654 123.109Z",
    fill: "#FE4747",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.279 191.438C76.9196 107.048 137.783 0 236.124 0C330.411 0 391.676 99.2082 349.379 183.399L267.869 348.808C308.726 411.932 371.58 397.026 413.681 284.176L354.88 316.634C345.925 321.986 334.472 315.992 333.777 305.589C333.379 299.61 336.846 294.044 342.391 291.762L422.857 258.565C430.463 258.058 437.419 262.846 439.656 270.127L461.365 342.414C463.73 350.287 459.288 358.591 451.423 361.003C442.479 363.746 433.237 357.709 432.166 348.423L422.857 287.518C388.01 416.518 303.808 445.244 249.307 380.49C225.091 416.731 179.783 433.769 135.282 433.769L78.2524 431.299L21.2231 428.829L79.0495 461.974C87.5217 466.83 88.8535 478.501 81.693 485.137C76.2174 490.213 67.7772 490.296 62.2018 485.331L4.38491 433.837C-1.48764 427.513 -1.45803 417.726 4.45269 411.437L62.2254 359.221C67.8472 354.14 76.4308 354.22 81.9571 359.405C89.0388 366.048 87.7446 377.626 79.3703 382.545L21.5358 416.518L135.282 414.049C171.072 414.049 211.344 383.611 228.849 352.912L127.279 191.438ZM246.305 327.264L320.011 168.672C351.34 106.312 305.962 32.829 236.124 32.829C163.283 32.829 118.202 112.119 155.503 174.627L246.305 327.264Z",
    fill: "#FE4747",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundIcon);
export default __webpack_public_path__ + "static/media/background_icon.0a44e643200214da0e15f4588bf6ee70.svg";
export { ForwardRef as ReactComponent };